import { render, staticRenderFns } from "./OpenIds.vue?vue&type=template&id=27427513&scoped=true"
import script from "./OpenIds.vue?vue&type=script&lang=js"
export * from "./OpenIds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27427513",
  null
  
)

export default component.exports